import { Component, OnInit, ViewChild, ElementRef, Renderer2, Inject, NgZone } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoginInfoComponent } from '../../user/login-info/login-info.component';
import { ICoreService } from 'app/+common/contracts/core.service.contract';
import { ActivatedRoute, Router } from '@angular/router';
import { LaundryInputOutput } from 'app/+core/common/model/laundry-input.model';
import { GarmentFull } from 'app/+core/common/model/garment-full.model';
import { Garment } from 'app/+core/common/model/garment.model';
import { IAuthenticationService } from 'app/+common/contracts/authentication.service.contract';
import { IInstanceService } from 'app/+common/contracts/instance-service.contract';


@Component({
    selector: 'sa-navigation',
    templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit
{
    public showError: boolean;
    public errorMessage: string;
    public infoCode: string;
    public garment: GarmentFull;
    @ViewChild("tagsearch") tagSearchElement: ElementRef;

    constructor(private renderer: Renderer2, 
                @Inject('ICoreService') private coreService: ICoreService, 
                @Inject('IAuthenticationService') private authService: IAuthenticationService, 
                @Inject('IInstanceService') private instanceService: IInstanceService, 
                private route: ActivatedRoute, private parentRouter: Router, private ngZone: NgZone)
    { }

    ngOnInit() 
    { 
    }

    onKey(event)
    {
        if (event.key === 'Enter' && this.infoCode.length > 0)
        {
            this.renderer.setProperty(this.tagSearchElement.nativeElement, 'value', '');

            try
            {
                // this.coreService.getGarmentByRFID(this.infoCode, "output").subscribe(res => { this.postProcessing(res) }, err => this.handleError(err));
                this.coreService.getGarmentByRFID(this.infoCode).subscribe(res => { this.postProcessing(res) }, err => this.handleError(err));
            }
            catch (ex)
            {
                console.log(ex);
            }
            this.infoCode = '';
        }
    }

    postProcessing(res)
    {
        let g: Garment = <Garment>res;
        let info = new LaundryInputOutput();
        if (g.id)
        {
            this.garment = new GarmentFull();
            this.garment.garment = g;
            this.garment.product = g.product;
            this.garment.person = g.owner;
            this.garment.productCategory = g.product.category;

            info.garment = g;
            info.userId = 1;
            info.device = "device-test";

            this.coreService.setSelectedGarment(g);
            this.navigateToNext();
        }
        else
            this.handleError("Capo non trovato");
    }


    // setTags(tags: string[])
    // {        
    //     console.log('Tags received from Read Component: ');
    //     console.log(tags);
    //     if (tags.length > 0)
    //         this.coreService.getGarmentByRFID(tags[0]).subscribe(res => { this.postProcessing(res) }, err => this.handleError(err));
    // }

    // setLastTag(tag: string)
    // {        
    //     console.log('Tag received from Read Component: ');
    //     console.log(tag);        
    //     this.coreService.getGarmentByRFID(tag).subscribe(res => { this.postProcessing(res) }, err => this.handleError(err));
    // }

    navigateToNext(): void
    {
        this.redirectTo('core/garments/' + this.garment.person.id + '/' + this.garment.garment.id);
        window.scrollTo(0, 0);
    }

    handleError(err)
    {
        this.showError = true;
        this.errorMessage = err;
    }

    // Ezio: very good trick to get around the "same route problem" in Angular: ngOnInit doesn't fire id the url is the same, evene with different params...
    // Wait for Angular 5 to solve using "onSameUrlNavigation" in Router Config
    redirectTo(uri: string)
    {
        this.parentRouter.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.parentRouter.navigate([uri]));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts